export function isMultiValueFilter<T extends {op: string}>(f: T) {
  return ['IN', 'NIN'].includes(f.op);
}

/**
 * In order to support multi-value filters, we need to be able to extract the filter values for Individual and MultiValue filters. Multivalue filters (such as IN | NIN) put a "*" in the name value and feed in the selections as an array of strings in the value field. Individual filters (such as = | !=) put the selection in the name field and a boolean in the value field.
 */
export function getCurrentSelections<
  T extends {
    key: {
      name: string;
      section: string;
    };
    op: 'IN' | 'NIN' | '=' | '!=';
    value: boolean | string[];
  }
>(filter: T): string[] {
  const names = isMultiValueFilter(filter)
    ? (filter.value as string[])
    : filter.key?.name ?? '';

  // make everything into an array
  const namesAsArray = Array.isArray(names) ? names : [names];

  // dump empty values "-", "*", ""
  return namesAsArray.filter(name => !['-', '*', ''].includes(name));
}
